import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data
    return data.map(item => ({ id: item.appointment_type_id, text: item.text }))
  }, [data])
}
